// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-picker-input {
  --_--preview-size: 16px;
}
.color-picker-input__preview-container {
  margin: 0 var(--g-spacing-1);
  overflow: hidden;
  position: relative;
  width: var(--_--preview-size);
  height: var(--_--preview-size);
}
.color-picker-input__preview-container::before {
  content: "";
  position: absolute;
  inset: 0px;
  border: 1px solid var(--g-color-line-generic);
}
.color-picker-input__preview-container, .color-picker-input__preview-container::before {
  border-radius: 2px;
}
.color-picker-input__preview {
  width: var(--_--preview-size);
  height: var(--_--preview-size);
}
.color-picker-input__palette {
  cursor: pointer;
  opacity: 0;
  width: calc(100% + 8px);
  height: calc(100% + 10px);
  position: absolute;
  left: -8px;
  top: 0;
}
.color-picker-input__palette_size-l {
  width: calc(100% + 8px);
  height: calc(100% + 12px);
}
.color-picker-input__opacity-input {
  width: 54px;
  margin-inline-end: -1px;
  border-inline-start: 1px solid var(--g-color-line-generic);
  padding-inline-start: var(--g-spacing-1);
}
.color-picker-input__opacity-end-content {
  margin-inline: var(--g-spacing-1);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/ColorPickerInput/ColorPickerInput.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ;AACI;EACI,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;AACR;AACQ;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,6CAAA;AACZ;AAEQ;EAEI,kBAAA;AADZ;AAKI;EACI,6BAAA;EACA,8BAAA;AAHR;AAMI;EACI,eAAA;EACA,UAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;AAJR;AAOI;EACI,uBAAA;EACA,yBAAA;AALR;AAQI;EACI,WAAA;EACA,uBAAA;EACA,0DAAA;EACA,wCAAA;AANR;AASI;EACI,iCAAA;AAPR","sourcesContent":[".color-picker-input {\n  --_--preview-size: 16px;\n}\n.color-picker-input__preview-container {\n  margin: 0 var(--g-spacing-1);\n  overflow: hidden;\n  position: relative;\n  width: var(--_--preview-size);\n  height: var(--_--preview-size);\n}\n.color-picker-input__preview-container::before {\n  content: \"\";\n  position: absolute;\n  inset: 0px;\n  border: 1px solid var(--g-color-line-generic);\n}\n.color-picker-input__preview-container, .color-picker-input__preview-container::before {\n  border-radius: 2px;\n}\n.color-picker-input__preview {\n  width: var(--_--preview-size);\n  height: var(--_--preview-size);\n}\n.color-picker-input__palette {\n  cursor: pointer;\n  opacity: 0;\n  width: calc(100% + 8px);\n  height: calc(100% + 10px);\n  position: absolute;\n  left: -8px;\n  top: 0;\n}\n.color-picker-input__palette_size-l {\n  width: calc(100% + 8px);\n  height: calc(100% + 12px);\n}\n.color-picker-input__opacity-input {\n  width: 54px;\n  margin-inline-end: -1px;\n  border-inline-start: 1px solid var(--g-color-line-generic);\n  padding-inline-start: var(--g-spacing-1);\n}\n.color-picker-input__opacity-end-content {\n  margin-inline: var(--g-spacing-1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
